import {
  Grid,
} from '@mui/material';
import {makeStyles} from "@mui/styles";
import "react-datepicker/dist/react-datepicker.css";

import TodayBox from "./TodayBox";

const useStyles = makeStyles(() => ({
  box:{
    marginLeft: 32,
    width: 236,
    height: 112,
    borderRadius:6,
    backgroundColor: "#FFFFFF",
    border: "1px solid rgba(241,243,251)",
  }
}));

export default function TodayContents(props: any){
  const { today } = props;
  const classes = useStyles();

  return(
    <>
      <Grid container direction={"row"} justifyContent={"space-between"}>
        <Grid item className={classes.box}>
          <TodayBox text={"주문완료"} count={today.InProgress} image={"icon_inprogress.svg"} color={"#eff8f3"}/>
        </Grid>
        <Grid item className={classes.box}>
          <TodayBox text={"배차완료"} count={today.Completed} image={"icon_completed.svg"} color={"#fbefee"}/>
        </Grid>
        <Grid item className={classes.box}>
          <TodayBox text={"운행완료"} count={today.Finished} image={"icon_finished.svg"} color={"#f0e5ff"}/>
        </Grid>
      </Grid>
    </>
  )
}